import { configureStore } from '@reduxjs/toolkit'
import FileNumberReducer from './dosya_sayisi/index'
import AgeNumberReducer from './yas_aralik/index'
import PageStateReducer from './page_state/index'

export default configureStore({
  reducer: {
    FileNumber: FileNumberReducer,
    AgeNumber: AgeNumberReducer,
    PageState: PageStateReducer,
  },
})
